export default __webpack_public_path__ + "static/media/william-logo.4d990607.svg";